import DOMPurify from "dompurify";

/**
 * HTML que vem de fora (formulário do freelancer, Jotform) só entra na tela
 * por aqui. Mantém formatação de texto (parágrafos, listas, negrito, links) e
 * remove script, eventos (onerror, onclick), iframe, style e afins.
 */
const ALLOWED_TAGS = ["p", "br", "strong", "b", "em", "i", "u", "ul", "ol", "li", "a", "span", "div", "h3", "h4", "blockquote"];

export function sanitizeHtml(html: string | null | undefined): string {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ["href", "target", "rel"],
    ALLOW_DATA_ATTR: false,
  });
}

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});
